import React, { memo } from 'react'

import { Icon, MenuOutline, Close } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

// Triangle Icon renders the glyph at its svgComponent's intrinsic size unless
// given one; the design calls for a 20px glyph inside the 32px button.
const ICON_SIZE = { width: '20', height: '20' }

function Hamburger({ isActive = false, onToggle }) {
  return (
    <button
      type="button"
      className="unified-nav__hamburger"
      aria-label={isActive ? 'Close menu' : 'Open menu'}
      aria-expanded={isActive}
      onClick={onToggle}
    >
      <Icon
        notSpaced
        color="dark"
        size={ICON_SIZE}
        svgComponent={isActive ? Close : MenuOutline}
      />
    </button>
  )
}

Hamburger.propTypes = {
  isActive: bool,
  onToggle: func.isRequired,
}

export default memo(Hamburger)
